import React, { useState } from "react";
import api from "../lib/api";
import { Card, Button } from "./ui";
import PresettleEditor, { fromServer, toPayload, useHutangOptions } from "./PresettleEditor";
import { fmtIDR, errMsg } from "../lib/utils";
import { toast } from "sonner";
import { X, ListChecks } from "lucide-react";

export const panjarAmountLocked = (p) => p.approval_status === "Approved" || !p.approval_id;

export default function PresettleModal({ panjar, orders, expenseCats, onClose, onSaved }) {
  const [items, setItems] = useState(fromServer(panjar.presettle_items || []));
  const [saving, setSaving] = useState(false);
  const hutangOptions = useHutangOptions(panjar.id);
  const follows = panjar.amount_mode === "items" && !panjarAmountLocked(panjar);

  const save = async () => {
    const bad = items.find((i) => parseFloat(i.amount) > 0 && ((i.target === "awb" && !i.awb_id) || (i.target === "finance" && !i.expense_category) || (i.target === "hutang" && !i.hutang_ref) || (i.target === "awb" && parseFloat(i.unpaid_amount) > 0 && !i.vendor_name)));
    if (bad) return toast.error("Lengkapi AWB / kategori / hutang / vendor di tiap item");
    setSaving(true);
    try {
      const { data } = await api.put(`/cash-advances/${panjar.id}/presettle`, { items: toPayload(items) });
      toast.success(follows ? `Rincian disimpan — nilai panjar jadi ${fmtIDR(data.amount)}` : "Rincian disimpan");
      onSaved(data);
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 z-50 flex items-center justify-center p-4" data-testid="presettle-modal">
      <Card className="w-full max-w-6xl p-6 max-h-[92vh] overflow-y-auto min-h-[520px]">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 className="font-heading font-bold text-xl inline-flex items-center gap-2"><ListChecks size={18} className="text-sky-600"/> Rincian Panjar — {panjar.number}</h3>
            <p className="text-xs text-slate-500 mt-1">
              {panjar.recipient_name} · nilai panjar <b>{fmtIDR(panjar.amount)}</b> ·{" "}
              {panjar.amount_mode === "items"
                ? (follows ? "mode Dari rincian — nilai panjar ikut total rincian sampai Approved" : "mode Dari rincian — nilai mengikuti approval (terkunci)")
                : "mode Glondongan"}
              . Rincian belum dijurnal; jurnal dibuat saat item dicentang di Settle.
            </p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X size={18}/></button>
        </div>
        <PresettleEditor items={items} setItems={setItems} orders={orders} expenseCats={expenseCats} hutangOptions={hutangOptions}
          amountLimit={follows ? null : panjar.amount}/>
        <div className="flex justify-end gap-2 pt-4 mt-4 border-t">
          <Button variant="secondary" onClick={onClose}>Batal</Button>
          <Button data-testid="presettle-save" disabled={saving} onClick={save}>{saving ? "Menyimpan..." : "Simpan Rincian"}</Button>
        </div>
      </Card>
    </div>
  );
}
